import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from "rxjs-compat";
import { AppConstant } from "src/app/app.constant";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class ProfileCardService {
  apiUrl: string;
  kendoDataUrl: string;
  constructor(
    private httpClient: HttpClient,
    private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl()
  }

  getUserProfile() {
    return this.httpClient.get(`${this.apiUrl}/getUserProfile/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
        }
      })
    ) as any as any;
  }
  updateUserProfile(user) {
    return this.httpClient.post(`${this.apiUrl}/updateUserProfile`, user).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getStudentLogs(id: number) {
    return this.httpClient.get(`${this.apiUrl}/getAllStudentLogs/` + id).pipe(
        map((response: any) => {
            return {
                data: response.data,
            };
        })
    ) as any as any;
}

}
